var _style, _g, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.6,377.1l38.6-104.4c-9.1-4.5-20.4-6.8-29.5-6.8c-15.9,0-31.8,6.8-43.1,15.9L376.6,377.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.9,290.9l-40.8,111.2c31.8-4.5,56.7-34,56.7-68.1C453.9,318.1,447,302.2,437.9,290.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.1,309c-2.3,9.1-4.5,15.9-4.5,27.2c0,27.2,15.9,49.9,36.3,61.3L322.1,309z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448,64h-21.3V21.3c0-11.8-9.6-21.3-21.3-21.3H384c-11.8,0-21.3,9.6-21.3,21.3V64H149.3V21.3 C149.3,9.6,139.8,0,128,0h-21.3C94.9,0,85.3,9.6,85.3,21.3V64H64C28.7,64,0,92.7,0,128v320c0,35.3,28.7,64,64,64h384 c35.3,0,64-28.7,64-64V128C512,92.7,483.3,64,448,64z M42.6,112h426.7v75H42.6V112z M469.4,448h-0.1c0,11.8-9.6,21.3-21.3,21.3H64 c-11.8,0-21.3-9.6-21.3-21.3V214.2h426.7L469.4,448L469.4,448z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 256,
    className: "st0",
    width: 52.3,
    height: 52.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 141.9,
    y: 256,
    className: "st0",
    width: 52.3,
    height: 52.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 220.7,
    y: 256,
    className: "st0",
    width: 52.3,
    height: 52.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 334,
    className: "st0",
    width: 52.3,
    height: 52.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 141.9,
    y: 334,
    className: "st0",
    width: 52.3,
    height: 52.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 220.7,
    y: 334,
    className: "st0",
    width: 52.3,
    height: 52.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 401.4,
    className: "st0",
    width: 52.3,
    height: 52.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 141.9,
    y: 401.4,
    className: "st0",
    width: 52.3,
    height: 52.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 220.7,
    y: 401.4,
    className: "st0",
    width: 52.3,
    height: 52.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendario);
export default __webpack_public_path__ + "static/media/calendario.618c75fccb8f2734c4829cb6475b1afb.svg";
export { ForwardRef as ReactComponent };